module.exports = "pegasus/assets/themelp1/travel/110.png";